import Vue from 'vue'
import Router from 'vue-router'
import Login from "./views/Login";
import NotFound from "./views/NotFound";
import Menu from "./views/Menu";
import Cards from "./views/Cards";
import Edit from "./views/Edit";
import Questions from "./views/Questions";
import QuestionsGenerations from "./views/QuestionsGenerations";
import EndCheck from "./views/EndCheck";
import QuestionNew from "./views/QuestionNew";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {name: 'login'},
    },
    {
      path: '/login',
      name: 'login',
      meta: {header: 'HeaderLogin', title: 'Модельная карта', loginPage: true},
      component: Login
    },
    {
      path: '/menu',
      name: 'menu',
      meta: {title: 'Модельная карта'},
      component: Menu
    },
    {
      path: '/designer/brands/new',
      name: 'brands-new',
      meta: {title: 'Добавить марку', viewData: ['brands', 'designerBrandViewNew']},
      component: Edit
    },
    {
      path: '/designer/brands/edit/:id',
      name: 'brands-edit',
      meta: {title: 'Редактировать', viewData: ['brands', 'designerBrandViewEdit']},
      component: Edit
    },
    {
      path: '/designer/brands/disable/:id',
      name: 'brands-disable',
      meta: {title: 'Отключить марку', viewData: ['brands', 'designerBrandViewDisable']},
      component: Edit
    },
    {
      path: '/designer/brands/delete/:id',
      name: 'brands-delete',
      meta: {title: 'Удалить марку', viewData: ['brands', 'designerBrandViewDelete']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/models/new',
      name: 'models-new',
      meta: {title: 'Добавить модель', viewData: ['models', 'designerModelViewNew']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/models/edit/:id',
      name: 'models-edit',
      meta: {title: 'Редактировать', viewData: ['models', 'designerModelViewEdit']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/models/disable/:id',
      name: 'models-disable',
      meta: {title: 'Отключить модель', viewData: ['models', 'designerModelViewDisable']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/models/delete/:id',
      name: 'models-delete',
      meta: {title: 'Удалить модель', viewData: ['models', 'designerModelViewDelete']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/generations/new',
      name: 'generations-new',
      meta: {title: 'Добавить поколение', viewData: ['generations', 'designerGenerationViewNew']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/generations/edit/:id',
      name: 'generations-edit',
      meta: {title: 'Редактировать', viewData: ['generations', 'designerGenerationViewEdit']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/generations/disable/:id',
      name: 'generations-disable',
      meta: {title: 'Отключить поколение', viewData: ['generations', 'designerGenerationViewDisable']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/generations/delete/:id',
      name: 'generations-delete',
      meta: {title: 'Удалить поколение', viewData: ['generations', 'designerGenerationViewDelete']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/new',
      name: 'designer-generations-questions-new',
      meta: {title: 'Добавить вопрос для поколения', viewData: ['questionsGenerations', 'designerGenerationQuestionsViewNew']},
      component: QuestionNew
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/edit/:id',
      name: 'designer-generations-questions-edit',
      meta: {title: 'Редактировать вопрос для поколения', viewData: ['questionsGenerations', 'designerGenerationQuestionsViewEdit']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/delete/:id',
      name: 'designer-generations-questions-delete',
      meta: {title: 'Удалить вопрос для поколения', viewData: ['questionsGenerations', 'designerGenerationQuestionsViewDelete']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/:q_id/new',
      name: 'answers-new',
      meta: {title: 'Добавить ответ', viewData: ['answers', 'designerAnswerViewNew']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/:q_id/edit/:id',
      name: 'answers-edit',
      meta: {title: 'Редактировать ответ', viewData: ['answers', 'designerAnswerViewEdit']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/:q_id/delete/:id',
      name: 'answers-delete',
      meta: {title: 'Удалить ответ', viewData: ['answers', 'designerAnswerViewDelete']},
      component: Edit
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/:q_id/disable/:id',
      name: 'answers-disable',
      meta: {title: 'Отключить ответ', viewData: ['answers', 'designerAnswerViewDisable']},
      component: Edit
    },
    {
      path: '/designer/brands',
      name: 'designer-brands',
      meta: {title: 'Марка', viewData: ['brands', 'designerBrandView']},
      component: Cards,
      children: [
        {
          path: ':brand',
          name: 'designer-models',
          meta: {title: 'Модель', viewData: ['models', 'designerModelView']},
          children: [
            {
              path: ':m_id',
              name: 'designer-generations',
              meta: {title: 'Поколение', viewData: ['generations', 'designerGenerationView']},
            }
          ]
        }
      ]
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id',
      name: 'designer-generations-questions',
      meta: {title: 'Вопросы'},
      component: QuestionsGenerations
    },
    {
      path: '/designer/brands/:brand/:m_id/:g_id/:q_id',
      name: 'designer-answers',
      meta: {title: 'Ответы', viewData: ['answers', 'designerAnswerView']},
      component: Cards
    },
    {
      path: '/questions',
      name: 'questions',
      meta: {title: 'Справочник вопросов'},
      component: Questions
    },
    {
      path: '/questions/new',
      name: 'questions-new',
      meta: {title: 'Добавить вопрос', viewData: ['questions', 'questionsViewNew']},
      component: Edit
    },
    {
      path: '/questions/edit/:id',
      name: 'questions-edit',
      meta: {title: 'Редактировать', viewData: ['questions', 'questionsViewEdit']},
      component: Edit
    },
    {
      path: '/questions/disable/:id',
      name: 'questions-disable',
      meta: {title: 'Отключить', viewData: ['questions', 'questionsViewDisable']},
      component: Edit
    },
    {
      path: '/questions/delete/:id',
      name: 'questions-delete',
      meta: {title: 'Удалить вопрос', viewData: ['questions', 'questionsViewDelete']},
      component: Edit
    },
    {
      path: '/check/brands',
      name: 'check-brands',
      meta: {title: 'Бренд вашего автомобиля', viewData: ['brands', 'checkBrandView']},
      component: Cards,
      children: [
        {
          path: ':brand',
          name: 'check-models',
          meta: {title: 'Модель вашего автомобиля', viewData: ['models', 'checkModelView']},
          children: [
            {
              path: ':m_id',
              name: 'check-generations',
              meta: {title: 'Поколение модели вашего автомобиля', viewData: ['generations', 'checkGenerationView']},
              children: [
                {
                  path: ':g_id',
                  name: 'check-questions',
                  children: [
                    {
                      path: ':q_id',
                      name: 'check-answers',
                      meta: {title: 'Ответы', viewData: ['answers', 'checkAnswerView']}
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/check/end/:brand/:m_id/:g_id/:q_id',
      name: 'check-end',
      meta: {title: 'Спасибо!'},
      component: EndCheck
    },
    {
      path: '*',
      component: NotFound,
      meta: {header: 'HeaderLogin', title: 'Страница не найдена'}
    }
  ]
})
